const Pin = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="M30.9409 3.4448c-1.4799-1.4798-3.8792-1.4798-5.3591 0-1.4799 1.48-1.4799 3.8793 0 5.3592l.8716.8716-11.2786 7.5025c-1.4888-1.2359-3.7016-1.1562-5.0969.2392-1.48 1.4798-1.48 3.8792 0 5.3591l13.7807 13.7807c1.4799 1.4799 3.8792 1.4799 5.3591 0 1.3956-1.3955 1.4751-3.6088.2386-5.0975l7.5025-11.2786.8725.8725c1.4799 1.4799 3.8793 1.4799 5.3591 0 1.4799-1.4799 1.4799-3.8793 0-5.3592L30.9409 3.4448ZM3.5699 43.0645l9.5699-13.3979 3.8279 3.828-13.3979 9.5699Z" />
    </svg>
);

export default Pin;
